const guideLabels = [
    {
        title: 'General Information',
        type: 'columns',
        fields: [
            { label: '[NUMERO]', description: 'number', visible: true },
            { label: '[REMITENTE]', description: 'sender_name', visible: true },
            { label: '[DESTINATARIO]', description: 'addressee_name', visible: true },
            { label: '[NOMBREEMPRESA]', description: 'company_name', visible: true },
            { label: '[DETALLES]', description: 'contain', visible: true },
            { label: '[TIPOENVIO]', description: 'shipping_type', visible: true },
            { label: '[FECHACREACION]', description: 'creation_date', visible: true }
        ]
    },
    {
        title: 'Agency and Contact',
        type: 'columns',
        fields: [
            { label: '[NOMBREAGENCIA]', description: 'agency_name', visible: true },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'agency_address',
                visible: true
            },
            { label: '[EMAILAGENCIA]', description: 'agency_email', visible: true },
            {
                label: '[TELEFONOAGENCIA]',
                description: 'agency_phone',
                visible: true
            },
            { label: '[AGENTE]', description: 'agent_name', visible: true }
        ]
    },
    {
        title: 'Links',
        type: 'columns',
        fields: [
            { label: '[LINKCASILLERO]', description: 'link_pobox', visible: true },
            { label: '[LINKTRACKING]', description: 'link_tracking', visible: true },
            { label: '[LINKEMPRESA]', description: 'link_company', visible: true }
        ]
    },
    {
        title: 'Notes and References',
        type: 'columns',
        fields: [
            { label: '[NOTA]', description: 'note', visible: true },
            { label: '[AUXILIAR]', description: 'aux', visible: true },
            { label: '[MASTERGUIDE]', description: 'master_guide', visible: true }
        ]
    },
    {
        title: 'Totals',
        type: 'columns',
        fields: [
            { label: '[TOTALPIEZAS]', description: 'total_pieces', visible: true },
            { label: '[TOTALPESO]', description: 'total_weight', visible: true },
            { label: '[TOTALVOLUMEN]', description: 'total_volume', visible: true }
        ]
    }
];

export default guideLabels;
